/** Matches AuthenticatedShell tablet threshold: mobile Inbox is below 768px. */
export const MOBILE_INBOX_BREAKPOINT_PX = 768;

export type MobileInboxPane = "list" | "conversation" | "details";

export type MobileInboxNavAction =
  | { type: "enter" }
  | { type: "select_conversation" }
  | { type: "back_to_list" }
  | { type: "open_details" }
  | { type: "back_to_conversation" };

/**
 * Pure mobile Inbox navigation reducer.
 * Does not own selectedConversationId — only which pane is visible.
 */
export function reduceMobileInboxPane(
  pane: MobileInboxPane,
  action: MobileInboxNavAction,
): MobileInboxPane {
  switch (action.type) {
    case "enter":
      return "list";
    case "select_conversation":
      return "conversation";
    case "back_to_list":
      return "list";
    case "open_details":
      return pane === "list" ? pane : "details";
    case "back_to_conversation":
      return pane === "details" ? "conversation" : pane;
    default: {
      const _exhaustive: never = action;
      return _exhaustive;
    }
  }
}

export function initialMobileInboxPane(): MobileInboxPane {
  return reduceMobileInboxPane("list", { type: "enter" });
}
